import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const onLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-[#050505] px-6 pt-28 pb-20">
      <div className="w-full max-w-md card-flat p-10 text-center">
        <Link to="/" className="inline-block mb-8">
          <span className="text-gold font-serif text-2xl tracking-[0.18em]">WEST LONDON</span>
          <span className="block text-white/60 text-xs tracking-[0.45em] uppercase mt-1">Stays · Admin</span>
        </Link>
        <h1 className="font-serif text-3xl text-white mb-3">Admin Sign-in</h1>
        <p className="text-white/55 text-sm mb-10">Sign in with your authorised Google account to manage properties and bookings.</p>
        <button data-testid="google-login-btn" onClick={onLogin} className="btn-gold w-full justify-center">
          <LogIn size={16} /> Continue with Google
        </button>
        {user && !user.is_admin && (
          <p data-testid="not-admin-msg" className="text-red-400 text-xs mt-6">Signed in as {user.email} — this account is not authorised as admin.</p>
        )}
        <p className="text-white/30 text-xs mt-8">Whitelisted via ADMIN_EMAILS in backend.</p>
      </div>
    </div>
  );
}
